import { getDataForRegisterResult } from 'apis/project.api';
import { useMemo } from 'react';
import { useQuery } from 'react-query';

const useGetDataForRegisterResult = (projectId, councilType, conds) => {
  const { data: data_, ...rest } = useQuery(
    ['getDataForRegisterResult', projectId],
    () => getDataForRegisterResult(projectId, councilType),
    {
      ...conds,
    }
  );

  const data = useMemo(() => data_?.data || [], [data_]);

  return { data, ...rest };
};

export default useGetDataForRegisterResult;
